
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BgComp extends Vue {
  // 步骤器进行的状态
  @Prop({default: 1}) active!: number
  stepData = [
    {
      step: '1',
      content: '信息填写'
    },
    {
      step: '2',
      content: '人脸识别'
    },
    {
      step: '3',
      content: '完成认证'
    }
  ]

}
